import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FormElement from 'components/FormElement';

const PointOfContactLab = ({ show, request }) => {
  if (!show) return null;

  const { pocFullName, pocEmail, pocPhone, tn, modelName, vendor } = request;
  const emailData = { tn, email: pocEmail, modelName, vendor };

  return (
    <div>
      <Form horizontal>
        <FormElement
          id="pocName"
          label="Point of Contact (POC)"
          value={pocFullName}
        />
        <FormElement 
            id="selectedEmail" 
            label="POC Email" 
            value={emailData} 
            type="emailLink"
        />
        <FormElement id="pocPhone" label="POC Phone" value={pocPhone} />
      </Form>
    </div>
  );
};

PointOfContactLab.propTypes = { show: PropTypes.bool };
PointOfContactLab.defaultProps = { show: true };

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(PointOfContactLab);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Laboratory/PointOfContact.js